"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconType = void 0;
var IconType;
(function (IconType) {
    IconType[IconType["None"] = 0] = "None";
    IconType[IconType["VirtualTour"] = 1] = "VirtualTour";
    IconType[IconType["Video"] = 2] = "Video";
    IconType[IconType["Exclusive"] = 3] = "Exclusive";
    IconType[IconType["All"] = 1000] = "All";
})(IconType = exports.IconType || (exports.IconType = {}));
